export const LANDING_PAGES = {
  "tiktok-shop-setup": {
    slug: "tiktok-shop-setup",
    stage: "not_started",
    service: "tiktok_shop_setup",
    seoTitle: "TikTok Shop 开店马来西亚 | 开店申请与设置协助 | TKShopMY",
    seoDesc: "TikTok Shop 开店协助（TikTok Shop setup Malaysia）：申请流程、资料准备、店铺设置和上线前检查。马来西亚本地团队，先在线咨询再决定。",
    keywords: "TikTok Shop 开店, TikTok Shop 怎么开, TikTok Shop setup Malaysia, TikTok Shop registration Malaysia, 马来西亚 TikTok Shop",
    kicker: "TikTok Shop 开店 · 马来西亚",
    h1: "TikTok Shop 开店，从申请到上线一次做对",
    sub: "TKShopMY 协助马来西亚新卖家处理 TikTok Shop 开店申请、资料准备、店铺设置和上线前检查。不确定自己的产品适不适合？先用 WhatsApp 问我们。",
    ctaPrimary: "免费 WhatsApp 了解合作",
    ctaNote: "无需填写表格 · 直接 WhatsApp 咨询",
    trustPoints: ["马来西亚本地团队", "一对一在线沟通", "先了解，再决定"],
    includesTitle: "开店协助包括什么",
    includes: [
      "卖家类型建议 —— 个人卖家还是 SSM 公司，哪个适合你",
      "所需资料清单 —— 一次准备齐，不来回补件",
      "店铺资料与类别设置 —— 店名、简介、取货与退货",
      "物流与收款配置 —— 用简单的语言讲清楚",
      "第一批商品结构 —— 先上什么、怎样上",
      "上线前检查 —— 确认没有遗漏才开张",
    ],
    whoFor: [
      "第一次开 TikTok Shop 的新卖家",
      "有实体生意、想增加线上渠道的商家",
      "申请或设置到一半卡住的人",
    ],
    steps: [
      { title: "WhatsApp 告诉我们你打算卖什么", desc: "打开 WhatsApp，简单说几句就可以。" },
      { title: "我们帮你理清步骤和资料", desc: "你的情况需要准备什么，一次讲清楚。" },
      { title: "陪你完成设置再上线", desc: "上线前帮你把店铺检查一遍。" },
    ],
    faqs: [
      {
        q: "开 TikTok Shop 需要 SSM 吗？",
        a: "不一定。个人卖家没有 SSM 也可以注册，但注册公司在部分类别和功能上更方便。我们会根据你卖的产品，告诉你哪条路更合适。",
      },
      {
        q: "TikTok Shop 开店需要多少钱？",
        a: "在平台注册本身免费，成交时平台会收取佣金和交易费。我们的开店咨询费用会在了解你的情况后、开始前先报清楚，没有隐藏收费。",
      },
      {
        q: "申请审核要多久？",
        a: "审核时间由 TikTok Shop 平台决定。资料完整、信息准确的申请能避开最常见的延迟，这正是我们会帮你检查的部分。",
      },
      {
        q: "你们可以保证开店申请一定通过吗？",
        a: "不能。审核完全由 TikTok Shop 决定。我们做的是确保你的资料和设置正确完整，去除申请被卡住的常见原因。",
      },
    ],
    finalTitle: "还不确定自己的产品适不适合 TikTok Shop？",
    finalCta: "WhatsApp 问一下",
    opsNote: {
      title: "一件代发 · 无需自行囤货",
      body: "如果你想开始 TikTok Shop，但不希望一开始就处理大量库存，也可以了解不同的合作模式。",
      cta: "WhatsApp 了解合作方式",
    },
  },
  "tiktok-shop-management": {
    slug: "tiktok-shop-management",
    stage: "managed_service",
    service: "tiktok_shop_management",
    seoTitle: "TikTok Shop 代运营马来西亚 | 店铺运营管理服务 | TKShopMY",
    seoDesc: "TikTok Shop 代运营与店铺管理（TikTok Shop management Malaysia）：日常运营、商品维护、活动规划和内容方向。马来西亚本地团队，合作前先谈清楚范围。",
    keywords: "TikTok Shop 代运营 马来西亚, TikTok Shop 运营, TikTok Shop management Malaysia, TikTok Shop agency Malaysia, TikTok Shop 管理",
    kicker: "TikTok Shop 代运营 · 马来西亚",
    h1: "没有时间管理 TikTok Shop？让专业团队帮你管",
    sub: "TKShopMY 为马来西亚商家提供 TikTok Shop 代运营与店铺运营支持：日常管理、商品维护、活动规划和内容方向。开始前先用 WhatsApp 聊清楚范围，再决定要不要合作。",
    ctaPrimary: "免费咨询 TikTok Shop",
    ctaNote: "无需填写表格 · 直接 WhatsApp 咨询",
    trustPoints: ["马来西亚本地团队", "范围透明再开始", "不适合会直接说"],
    includesTitle: "代运营包括什么",
    includes: [
      "日常订单与客服消息处理",
      "商品页面、价格与库存维护",
      "活动与促销规划 —— 优惠券、套装、平台活动档期",
      "内容方向配合 —— 让视频和店铺互相配合",
      "每周优先事项 —— 该修什么、该推什么",
      "定期汇报 —— 做了什么，改变了什么",
    ],
    whoFor: [
      "有店铺、但没时间每天管理的卖家",
      "没有内部电商团队的 SME",
      "有流量但转化表现不理想的店铺",
    ],
    steps: [
      { title: "告诉我们你的店铺现状", desc: "卖什么、做了多久、卡在哪里。" },
      { title: "我们先看店铺、谈清楚范围", desc: "哪些部分由我们处理，开始前写清楚。" },
      { title: "确认后开始执行", desc: "按谈好的节奏运营，定期向你汇报。" },
    ],
    faqs: [
      {
        q: "代运营每天实际做什么？",
        a: "处理日常运营工作：订单和客服消息、商品信息维护、活动档期准备、店铺形象检查、问题及早发现。具体范围在开始前和你确认清楚。",
      },
      {
        q: "你们需要我的 TikTok 账号密码吗？",
        a: "权限安排会在开始前透明讨论，按你舒服的方式进行。我们不会要求超出服务范围的权限。",
      },
      {
        q: "代运营费用怎么算？",
        a: "看范围 —— 只做商品维护和完整日常运营不一样。先在线告诉我们你的店铺情况，我们会给你清楚的报价，没有隐藏收费。",
      },
      {
        q: "代运营可以保证销量吗？",
        a: "没有人可以诚实地保证。流量和销量取决于平台、产品和市场。代运营的价值是把运营基础稳定做好，让店铺有持续成长的前提。",
      },
    ],
    finalTitle: "先让我们看看你的店铺，再谈合作",
    finalCta: "WhatsApp 聊聊我的店",
    opsNote: {
      title: "从运营到履约，也可以有更轻的模式。",
      body: "除了店铺与运营支持，也可以了解一件代发及无需自行囤货的合作方式。",
      cta: "WhatsApp 咨询合作模式",
    },
  },
  "tiktok-shop-seller-malaysia": {
    slug: "tiktok-shop-seller-malaysia",
    stage: "exploring",
    service: "seller_acquisition",
    seoTitle: "TikTok Shop 马来西亚 | 开店、一件代发、无需囤货合作方式 | TKShopMY",
    seoDesc: "想在马来西亚开始 TikTok Shop？无论你已经有产品、经营实体店或是 Shopee / Lazada 卖家，还是想了解电商副业、一件代发或无需自行囤货的线上生意方式，都可以先在线咨询。TKShopMY 提供开店、产品方向与后续运营支持。",
    keywords: "TikTok Shop Malaysia, TikTok Shop 马来西亚, TikTok Shop 开店, TikTok Shop 创业, TikTok Shop 副业, TikTok Shop 一件代发, TikTok Shop 无需囤货, 无货源电商, TikTok 电商, 马来西亚电商, 电商创业, 电商副业, 线上生意, 网上开店, 一件代发, 无需囤货, 线上副业",
    kicker: "马来西亚 TikTok Shop 合作咨询",
    h1: "想做 TikTok Shop？",
    h1Line2: "现在开放合作咨询",
    sub: "无论你已经有产品、正在做 Shopee / Lazada，还是想做电商副业、了解一件代发，都可以先免费了解适合自己的方式。",
    subExtra: "有产品、没产品都可以先咨询。先了解，再决定要不要开始。TKShopMY 专注马来西亚 TikTok Shop 招商合作咨询，提供开店、产品方向、一件代发合作方式及后续运营支持。",
    ctaPrimary: "免费 WhatsApp 了解合作",
    ctaSecondary: "了解怎样开始",
    ctaNote: "无需填写表格 · 直接 WhatsApp 咨询",
    trustPoints: ["免费 WhatsApp 咨询", "免费了解合作方式", "有产品 / 没产品都可了解", "可了解一件代发", "马来西亚市场", "一对一沟通"],
    includesTitle: "我们会先了解你的情况",
    includes: [
      "你现在是商家还是刚准备开始",
      "已经有产品，还是想了解一件代发",
      "是否希望采用无需自行囤货的方式",
      "TikTok Shop 开店需要准备什么",
      "比较适合从哪些产品方向开始",
      "后续上架和运营可以怎样安排",
    ],
    audiences: [
      { title: "有实体店的商家", desc: "想增加 TikTok Shop 销售渠道" },
      { title: "Shopee / Lazada 卖家", desc: "想多增加一个电商渠道" },
      { title: "有自己品牌或产品的人", desc: "想了解 TikTok Shop 是否适合自己的产品" },
      { title: "想做电商副业的人", desc: "想了解怎样从 TikTok Shop 开始" },
      { title: "没有产品的新手", desc: "可以先了解一件代发和产品方向" },
      { title: "不想自行囤货的人", desc: "可以了解无需自行囤货的合作模式" },
    ],
    audienceCta: "先免费了解适合我的方式",
    assistItems: [
      { title: "TikTok Shop 开店准备", desc: "协助了解开店前需要准备的基本资料和流程。" },
      { title: "产品方向", desc: "根据实际情况了解适合的产品和销售方向。" },
      { title: "一件代发合作方式", desc: "如果暂时不想自行准备库存，可以了解一件代发的合作方式。" },
      { title: "无需自行囤货", desc: "根据合作模式，可以了解无需自行囤货的合作方式。" },
      { title: "商品上架", desc: "协助了解商品资料、上架和基础店铺设置。" },
      { title: "TikTok Shop 运营", desc: "提供后续店铺运营方向和相关支持。" },
      { title: "后续咨询", desc: "开始后仍可以继续咨询相关 TikTok Shop 问题。" },
    ],
    dropship: {
      title: "暂时没有产品，也可以先了解",
      intro1: "不是每个人开始 TikTok Shop 时，都已经准备好产品和库存。",
      intro2: "如果你想开始电商，但暂时没有自己的产品，可以先了解一件代发和无需自行囤货的合作方式。我们会先说明：",
      items: ["产品来源", "合作方式", "商品价格", "基本成本", "履约方式", "店铺运营方式"],
      outro: "然后再由你决定是否适合继续。",
      disclaimer: "一件代发和无需自行囤货属于合作方式，并不代表零成本，也不保证订单、销量或收入。实际结果会受到产品、市场需求、定价、内容和运营等因素影响。",
    },
    stepsTitle: "开始 TikTok Shop，可以先从了解开始",
    steps: [
      { title: "告诉我们你的情况", desc: "例如：已经有产品 / 没有产品 / 有实体店 / Shopee 卖家 / 想做副业。" },
      { title: "了解适合的方式", desc: "我们会说明：TikTok Shop 开店、一件代发、产品方向或运营方式。" },
      { title: "再决定是否继续", desc: "先了解清楚，觉得适合再继续。" },
    ],
    stepsCta: "免费咨询 TikTok Shop",
    faqs: [
      {
        q: "没有自己的产品可以开始吗？",
        a: "可以先了解一件代发或其他产品合作方式。实际是否适合，需要根据你的情况和合作条件判断。",
      },
      {
        q: "一定要自己囤货吗？",
        a: "不一定。部分合作方式可以无需自行囤货，具体产品和履约方式需要进一步确认。",
      },
      {
        q: "完全没有 TikTok Shop 经验可以吗？",
        a: "可以。我们可以先协助你了解开店流程、产品方向和基本运营方式。",
      },
      {
        q: "已经有 Shopee 或 Lazada 店可以吗？",
        a: "可以。如果已经有电商经验，可以进一步了解如何增加 TikTok Shop 这个销售渠道。",
      },
      {
        q: "可以当副业做吗？",
        a: "可以先了解。实际需要投入的时间和资源，会根据选择的产品和运营方式不同。",
      },
      {
        q: "是否保证有订单？",
        a: "不会。TikTok Shop 的实际表现受到产品、价格、市场需求、内容和运营等因素影响，我们不会保证订单、销量或收入。",
      },
      {
        q: "无需囤货是不是代表完全不用成本？",
        a: "不是。无需自行囤货只代表其中一种合作模式，实际仍可能涉及平台、产品、履约、运营或其他相关成本。",
      },
    ],
    finalTitle: "先免费了解，再决定是否合作",
    finalSub: "我们提供免费初步咨询，先了解你的情况和适合的合作方向。咨询本身不收费，是否继续合作，由你了解清楚后再决定。",
    finalCta: "免费 WhatsApp 了解合作",
  },
};
